import { useParams, Link } from 'react-router-dom';
import { getGameById, getModById } from '../data/mods';
import './ModDetails.css';

function ModDetails() {
  const { gameId, modId } = useParams();
  const game = getGameById(gameId);
  const mod = getModById(gameId, modId);

  if (!game || !mod) {
    return (
      <div className="mod-details">
        <div className="not-found">
          <h1>Mod Not Found</h1>
          <p>The mod you're looking for doesn't exist.</p>
          <Link to="/" className="back-link">Back to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mod-details">
      <Link to={`/game/${gameId}`} className="back-link">
        Back to {game.name} Mods
      </Link>

      <div className="mod-content">
        <div className="mod-main">
          <div className="mod-hero">
            {mod.thumbnail ? (
              <img src={mod.thumbnail} alt={mod.name} className="mod-thumbnail" />
            ) : (
              <div className="mod-thumbnail-placeholder">{mod.name[0]}</div>
            )}
          </div>

          <div className="mod-info">
            <h1>{mod.name}</h1>
            <p className="mod-short-desc">{mod.shortDescription}</p>

            {mod.tags && mod.tags.length > 0 && (
              <div className="mod-tags">
                {mod.tags.map(tag => (
                  <span key={tag} className="mod-tag">{tag}</span>
                ))}
              </div>
            )}

            <div className="mod-description-full">
              <h2>Description</h2>
              <div className="description-content">
                {mod.fullDescription.trim().split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <aside className="mod-sidebar">
          <div className="sidebar-card">
            <h3>Download</h3>
            <a
              href={mod.curseforgeUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="download-btn"
            >
              Download on CurseForge
            </a>
          </div>

          <div className="sidebar-card">
            <h3>Details</h3>
            <dl className="mod-meta-list">
              <div className="meta-item">
                <dt>Version</dt>
                <dd>{mod.version}</dd>
              </div>
              {mod.gameVersion && (
                <div className="meta-item">
                  <dt>Game Version</dt>
                  <dd>{mod.gameVersion}</dd>
                </div>
              )}
              <div className="meta-item">
                <dt>Game</dt>
                <dd>{game.name}</dd>
              </div>
            </dl>
          </div>
        </aside>
      </div>

      {mod.screenshots && mod.screenshots.length > 0 && (
        <section className="screenshots-section">
          <h2>Screenshots</h2>
          <div className="screenshots-grid">
            {mod.screenshots.map((screenshot, index) => (
              <img
                key={index}
                src={screenshot}
                alt={`${mod.name} screenshot ${index + 1}`}
                className="screenshot"
              />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

export default ModDetails;
